/* eslint-disable react/react-in-jsx-scope */
import {h} from 'preact';
import WrapperListAssociatedUsers from './wrapper-list-associated-users';

const AssociatedUsersApp = () => (
	<div>
		<WrapperListAssociatedUsers />
	</div>
);

export default AssociatedUsersApp;
